import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

function PublicRoute({ children }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const employeeId = sessionStorage.getItem("employeeId");
    
    // Not logged in → show the public page (login/forgotpassword)
    if (!employeeId) { 
      setStatus('allowed'); 
      return; 
    }

    // Already logged in → verify and redirect to their home
    fetch('/api/verifyRole', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ employeeId, allowedRoles: ['HRAdmin', 'Employee'] })
    })
    .then(res => res.json())
    .then(data => setStatus(data.allowed ? 'redirect' : 'allowed'))
    .catch(() => setStatus('allowed'));
  }, []);

  if (status === 'loading') return <div>Loading...</div>;

  if (status === 'redirect') {
    const role = sessionStorage.getItem("role");
    // Already logged in → send to their home
    return role === 'HRAdmin' 
      ? <Navigate to="/dashboard" replace /> 
      : <Navigate to="/submissions" replace />;
  }

  return children; // not logged in → show login page
}

export default PublicRoute;